module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SI - Slovenia.c07d2fbc.svg";